export function JournalSkeleton({
	variant = "default",
}: {
	variant?: "default" | "compact"
}) {
	const count = variant === "compact" ? 1 : 3
	// Stable keys for a fixed-length skeleton list. The rows are visually
	// identical placeholders, but React still wants distinct keys; the
	// array length never mutates so a static set is safe and biome's
	// no-array-index-key rule is satisfied.
	const rowKeys = Array.from({ length: count }, (_, i) => `skeleton-${i}`)
	return (
		<div>
			{rowKeys.map((key) => (
				<div
					key={key}
					data-testid="journal-skeleton-row"
					className="animate-pulse flex items-start gap-3 py-3 border-b border-border"
				>
					<div className="w-8 h-8 rounded bg-muted" />
					<div className="flex-1 space-y-2">
						<div className="h-4 bg-muted rounded w-1/2" />
						<div className="h-3 bg-muted rounded w-1/3" />
					</div>
					<div className="h-3 bg-muted rounded w-12" />
				</div>
			))}
		</div>
	)
}
